export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const FORGOTTEN_PASSWORD = 'FORGOTTEN_PASSWORD';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNED_OUT = 'SIGNED_OUT';
